import { graphql } from "@/types/gql";

export const QUERY_GET_PARKING_METERS = graphql(`
  query GetParkingMeters($cityId: String!) {
    getParkingMeters(cityId: $cityId) {
      id
      name
      address {
        city
        country
        postalCode
        province
        streetName
        streetNumber
      }
      status
      externalId
      location
      cityId
      batteryLevel
      lastMaintenanceDate
      operator
      brand
      model
      zone
      options {
        cash
        creditCard
        contactless
      }
    }
  }
`);

export const QUERY_CREATE_PARKING_METER = graphql(`
  mutation createParkingMeter($createParkingMeterInput: CreateParkingMeterInput!) {
    createParkingMeter(createParkingMeterInput: $createParkingMeterInput) {
      id
      name
      address {
        city
        country
        postalCode
        province
        streetName
        streetNumber
      }
      status
      externalId
      location
      cityId
      batteryLevel
      lastMaintenanceDate
      operator
      brand
      model
      zone
      options {
        cash
        creditCard
        contactless
      }
    }
  }
`);

export const QUERY_UPDATE_PARKING_METER = graphql(`
  mutation updateParkingMeter($updateParkingMeterInput: UpdateParkingMeterInput!) {
    updateParkingMeter(updateParkingMeterInput: $updateParkingMeterInput) {
      id
      name
      address {
        city
        country
        postalCode
        province
        streetName
        streetNumber
      }
      status
      externalId
      location
      cityId
      batteryLevel
      lastMaintenanceDate
      operator
      brand
      model
      zone
      options {
        cash
        creditCard
        contactless
      }
    }
  }
`);

export const QUERY_REMOVE_PARKING_METER = graphql(`
  mutation removeParkingMeter($meterId: String!) {
    removeParkingMeter(meterId: $meterId) {
      id
    }
  }
`);
